import { createReducer, createSelector, on } from '@ngrx/store';
import { RegisteredEmployeeView } from '@iota/inh-core-v1-management-client';
import {
    LoadRegisteredEmployeeCounts,
    LoadRegisteredEmployeeCountsFailure,
    LoadRegisteredEmployeeCountsSuccess,
    LoadRegisteredEmployeeList,
    LoadRegisteredEmployeeListFailure,
    LoadRegisteredEmployeeListSuccess,
    RegisteredEmployeeCounts
} from '../actions/registered-employee.actions';
import { DEFAULT_PAGE_SIZE } from '../../shared/constants-and-enums/pagination';
import { AppState } from '../store';

export interface RegisteredEmployeeState {
    paginatedLoading: boolean;
    employees: RegisteredEmployeeView[];
    totalElements: number;
    pageIndex: number;
    pageSize: number;
    countsLoading: boolean;
    counts: RegisteredEmployeeCounts | null;
    error: any;
}

export const initialState: RegisteredEmployeeState = {
    paginatedLoading: false,
    employees: [],
    totalElements: 0,
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    countsLoading: false,
    counts: null,
    error: undefined
};

export const registeredEmployeeReducer = createReducer(
    initialState,
    on(LoadRegisteredEmployeeList, (state) => ({
        ...state,
        paginatedLoading: true
    })),
    on(LoadRegisteredEmployeeListSuccess, (state, { employees, totalElements, pageIndex, pageSize }) => ({
        ...state,
        paginatedLoading: false,
        employees,
        totalElements,
        pageIndex,
        pageSize
    })),
    on(LoadRegisteredEmployeeListFailure, (state, { error }) => ({
        ...state,
        paginatedLoading: false,
        error
    })),
    on(LoadRegisteredEmployeeCounts, (state) => ({
        ...state,
        countsLoading: true
    })),
    on(LoadRegisteredEmployeeCountsSuccess, (state, { counts }) => ({
        ...state,
        countsLoading: false,
        counts
    })),
    on(LoadRegisteredEmployeeCountsFailure, (state, { error }) => ({
        ...state,
        countsLoading: false,
        error
    }))
);

export const registeredEmployeeState = (state: AppState) => state.registeredEmployeeState;

export const registeredEmployeePaginatedLoading = createSelector(registeredEmployeeState, (state) => state.paginatedLoading);
export const registeredEmployeePaginatedEmployees = createSelector(registeredEmployeeState, (state) => state.employees);
export const registeredEmployeeTotalElements = createSelector(registeredEmployeeState, (state) => state.totalElements);
export const registeredEmployeePageIndex = createSelector(registeredEmployeeState, (state) => state.pageIndex);
export const registeredEmployeePageSize = createSelector(registeredEmployeeState, (state) => state.pageSize);
export const registeredEmployeeCounts = createSelector(registeredEmployeeState, (state) => state.counts);
